import {EntityStateAdapter} from '@/store/base.store';
import {ChallengeModel} from '@/models/challenge.model';
import store from '@/store';
import {Action, Module} from 'vuex-module-decorators';
import {ChallengesApi} from '@/api/challenges.api';
import {take} from 'rxjs/operators';


export const featureKey = 'challenges_incoming';

// @ts-ignore
if (store.state.challenges_incoming) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class ChallengesInComingStoreModule extends EntityStateAdapter<ChallengeModel> {

  get challenges(): ChallengeModel[] {
    return super.entities;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  get loading(): boolean {
    return super.loading;
  }

  get challengesByTag(): (tag: string) => ChallengeModel[] {
    return (tag: string) => this._entities.filter((v) => {
      return v.tags?.filter((t) => t.name == tag)
    })
  }

  @Action({commit: 'upsertMany', rawError: true})
  async fetchAll(data: { page: number, tag?: string }): Promise<ChallengeModel[]> {
    this.updateLoading(true);

    const response = await new ChallengesApi()
      .getChallengesbyFilter('comming_soon', data.page, data.tag)
      .pipe(take(1))
      .toPromise();

    this.context.commit('updateAllPageParams', response);
    return response.data
  }
}
